import { render, staticRenderFns } from "./GridForm.vue?vue&type=template&id=6baff302&"
import script from "./GridForm.vue?vue&type=script&lang=ts&"
export * from "./GridForm.vue?vue&type=script&lang=ts&"
import style0 from "./GridForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports